module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_floewr_wall-20229d584a3fd02741b79baee94805f9.jpg";